// extracted by mini-css-extract-plugin
export var center = "index-module--center--UXl9t";
export var text = "index-module--text--hMV5y";
export var button = "index-module--button--1khAT";
export var alternating_text = "index-module--alternating_text--1cIWu";
export var noun = "index-module--noun--1Vxuv";
export var alternate = "index-module--alternate--1M0zg";